import FormControl from '@mui/material/FormControl';
import React from 'react';
import { CampaignSearchResult, SearchElementType } from '@qualifio/data-search-api-client';
import { DataSearch } from '@qualifio/data-search-ui';
import { Module } from '@loyalty/shared-common/organisation-api-client';
import { useAccounts } from '../../../../../accounts/AccountsContext';
import { useApi } from '../../../../../shared/api-client/ApiClientProvider';
import { useProgram } from '../../../../../loyalty/ProgramContext';

export function CampaignSearchWidget(props: any) {
  const { value, setValue, config, readonly, placeholder, customProps, maxLength } = props;
  const { currentAccount } = useAccounts();
  const { program } = useProgram();
  const { dataSearchApi } = useApi();

  return (
    <FormControl>
      <DataSearch
        dataSearchApiClient={dataSearchApi}
        module={Module.LOYALTY}
        externalTenantId={currentAccount.id}
        entityId={program.id}
        searchCriteria={{ campaign: true }}
        value={value ? { type: SearchElementType.campaign, uniqueId: value } : null}
        onChange={val => setValue((val as CampaignSearchResult)?.identifier.uniqueId)}
        error
      />
    </FormControl>
  );
}
